function getBaseUrl(defaultLang, lang, url) {
  if (defaultLang !== lang) {
    return `/${lang}/${url}`;
  }

  return `/${url}`;
}

module.exports = getBaseUrl;
